

<div class="on-radios__item">
<!--
      <input  contenteditable
              [attr.disabled]="disable?true:null"
              id="{{xid}}"   
              [(ngModel)]="input"
              [value]="value"
              [name]="name"              
              (change)="valueChanged()"
              [className]="inputClass"  [style]="inputStyle" 
              type="radio">
              -->

      <label for="{{xid}}"
            [className]="labelClass"                    
            [style]="labelStyle" 
            [translateParams]="labelParam" translate>
            <span [innerHTML]="label|translate:labelParam"></span>
            <ng-content></ng-content>
      </label>
</div>

